// Dates anchoring the reconstruction timeline
const CLOSURE_DATE = new Date('2025-10-27T00:00:00Z');
const REOPEN_DATE = new Date('2027-03-30T00:00:00Z');

const DAY_MS = 24 * 60 * 60 * 1000;

function daysBetween(a, b) {
  // Positive = a is after b
  return Math.floor((a.getTime() - b.getTime()) / DAY_MS);
}

function computeStat(stat, areas) {
  const now = new Date();
  switch (stat.kind) {
    case 'days-since-closure': {
      const d = Math.max(0, daysBetween(now, CLOSURE_DATE));
      return { value: String(d), suffix: stat.suffix || '' };
    }
    case 'days-until-reopen': {
      const d = Math.max(0, daysBetween(REOPEN_DATE, now));
      return { value: String(d), suffix: stat.suffix || '' };
    }
    case 'areas-count': {
      return { value: String((areas || []).length), suffix: stat.suffix ?? '' };
    }
    case 'avg-completion': {
      const list = areas || [];
      if (!list.length) return { value: '0', suffix: stat.suffix || '%' };
      const avg = Math.round(
        list.reduce((sum, a) => sum + (Math.max(0, Math.min(100, parseInt(a.progress_percent ?? 0, 10) || 0))), 0) / list.length
      );
      return { value: String(avg), suffix: stat.suffix || '%' };
    }
    default:
      return { value: stat.value ?? '0', suffix: stat.suffix ?? '' };
  }
}

export default function StatsSection({ settings, areas }) {
  const stats = settings?.stats || [
    { kind: 'days-since-closure', label: 'Days Since Closure', suffix: '' },
    { kind: 'days-until-reopen', label: 'Days to Reopen', suffix: '' },
    { kind: 'areas-count', label: 'Areas Reconstructed', suffix: '' },
    { kind: 'avg-completion', label: 'Project Completion', suffix: '%' },
  ];
  const bgColor = settings?.stats_bg_color || '#003DA5';

  return (
    <section
      data-testid="stats-section"
      className="py-16 md:py-20 px-4 md:px-8"
      style={{ backgroundColor: bgColor }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, idx) => {
            const { value, suffix } = computeStat(stat, areas);
            return (
              <div key={idx} data-testid={`stat-${idx}`} className="text-center">
                <p className="text-4xl md:text-5xl tracking-tight font-medium mb-2" style={{ fontFamily: "'Cormorant Garamond', serif", color: '#FFB3A6' }}>
                  {value}
                  {suffix && <span className="text-2xl md:text-3xl">{suffix}</span>}
                </p>
                <p className="text-xs tracking-[0.15em] uppercase font-bold" style={{ fontFamily: 'Manrope, sans-serif', color: '#A3D4D4' }}>
                  {stat.label}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
